const registry = new Map();
export function registerProvider(id, ctor) {
    registry.set(id, ctor);
}
export function hasProvider(id) {
    return registry.has(id);
}
export function unregisterProvider(id) {
    registry.delete(id);
}
/** Build the providers a router should run with, based on user config. */
export function createProvidersFromConfig(config) {
    const out = [];
    for (const [id, sub] of Object.entries(config.providers)) {
        if (!sub || typeof sub !== 'object')
            continue;
        const enabled = sub.enabled === true;
        if (!enabled)
            continue;
        const ctor = registry.get(id);
        if (!ctor)
            continue;
        try {
            out.push(ctor(sub));
        }
        catch {
            // Provider construction failure is non-fatal — we proceed without it.
        }
    }
    return out;
}
//# sourceMappingURL=provider-factory.js.map